import * as s from "zod";
const i = (e, a) => {
  if (e.message)
    return { message: e.message };
  switch (e.code) {
    case s.ZodIssueCode.too_small:
      if (e.type === "string")
        return { message: "Champ requis" };
      break;
    case s.ZodIssueCode.invalid_type:
      if (e.code === "invalid_type" && (e.received === "undefined" || e.received === "null"))
        return { message: "Champ requis" };
      break;
    case s.ZodIssueCode.invalid_string:
      return e.validation === "email" ? { message: "Email invalide" } : { message: "Champ invalide" };
    default:
      return { message: a.defaultError };
  }
  return { message: a.defaultError };
};
export {
  i as defaultErrorMap
};
//# sourceMappingURL=defaultErrorMap.js.map
